module.exports = __webpack_public_path__ + "img/pizza-day.39e3d5fa.png";